const genFormValidateMotionStyle = token => {
  const {
    componentCls
  } = token;
  const helpCls = "".concat(componentCls, "-show-help");
  const helpItemCls = "".concat(componentCls, "-show-help-item");
  return {
    [helpCls]: {
      // Explain holder
      transition: "opacity ".concat(token.motionDurationSlow, " ").concat(token.motionEaseInOut),
      '&-appear, &-enter': {
        opacity: 0,
        '&-active': {
          opacity: 1
        }
      },
      '&-leave': {
        opacity: 1,
        '&-active': {
          opacity: 0
        }
      },
      // Explain
      [helpItemCls]: {
        overflow: 'hidden',
        transition: "height ".concat(token.motionDurationSlow, " ").concat(token.motionEaseInOut, ",\n                     opacity ").concat(token.motionDurationSlow, " ").concat(token.motionEaseInOut, ",\n                     transform ").concat(token.motionDurationSlow, " ").concat(token.motionEaseInOut, " !important"),
        ["&".concat(helpItemCls, "-appear, &").concat(helpItemCls, "-enter")]: {
          transform: "translateY(-5px)",
          opacity: 0,
          '&-active': {
            transform: 'translateY(0)',
            opacity: 1
          }
        },
        ["&".concat(helpItemCls, "-leave-active")]: {
          transform: "translateY(-5px)"
        }
      }
    }
  };
};
export default genFormValidateMotionStyle;